import { Box, Grid, Tab, Tabs, Typography, styled } from "@mui/material";

import AccessUsers from "../AccessUsers";
import InformationUsers from "../InformationUsers";
import SendFile from "./Component/SendFile";
import SwipeableViews from "react-swipeable-views";
import { useState } from "react";

export function UploadFile() {
  const [value, setValue] = useState(0);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <Grid item xs={12} mt={5}>
      <TabsStyle
        value={value}
        onChange={handleChange}
        aria-label="disabled tabs example"
      >
        <Tab value={0} label="اطلاعات کاربری " />

        <Tab value={1} label="دسترسی ها " />

        <Tab value={2} label="ارسال مدارک " />
      </TabsStyle>

      <SwipeableViews
        axis={"x-reverse"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <Box pt={2} value={value} index={0}>
          <InformationUsers />
        </Box>

        <Box pt={2} value={value} index={1}>
          <AccessUsers />
        </Box>

        <Box pt={2} value={value} index={2}>
          <BoxUploadFile>
            <Typography variant="h6" textAlign="right" fontWeight="400">
              لطفا یکی از مدارک زیر را جهت احراز هویت برای ما آپلود کنید
            </Typography>

            <SendFile />
          </BoxUploadFile>
        </Box>
      </SwipeableViews>
    </Grid>
  );
}

const BoxUploadFile = styled(Box)(({ theme }) => ({
  background: theme.palette.background.primaryGradient,
  borderRadius: "10px",
  border: `1px solid ${theme.palette.modules.border}`,
  padding: theme.spacing(2),
}));

const TabsStyle = styled(Tabs)(({ theme }) => ({
  direction: "rtl",
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
  },
}));

export default UploadFile;
